import { makeStyles } from "@material-ui/core";
import Color from "../../../../../styles/Color";

export const useStyleFinanceManage = makeStyles(theme => ({
    itemDD: {
        padding: ".75rem 1rem",
        backgroundColor: "#0000",
        boxShadow: "0 1px 0 0 #efefefa0",
        maxWidth: "100%",
        overflow: "hidden",
        whiteSpace: "pre-line",
    },
    btnAcStatus: {
        background: "#efefef",
        color: "#bbb",
        fontSize: 22,
        fontWeight: 600,
        width: "100%",
        marginBottom: 15,
        transition: "all .25s",
        "&.active": {
            background: "linear-gradient(90deg, #00B0E1 0%, #9DDDFC 100%)",
            color: "#fff",
        },
    },
    titleCard: {
        color: "#fff",
        textAlign: "center",
        background: "linear-gradient(90deg, #00B0E1 0%, #9DDDFC 100%)",
        height: "12%",
        fontSize: 18,
        fontWeight: 600,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0,
    },
    boxListUserWait: {
        overflowY: "scroll",
    },
    boxlistRoom: {
        height: 50,
        textAlign: "center",
        padding: "1.25rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        background: "linear-gradient(90deg, #CFD9DF 0%, #E2EBF0 100%)",
        color: "#fff",
        transition: "all .15s",
        borderTopRightRadius: 5,
        borderTopLeftRadius: 5,
        transform: "translateY(10px)",
        "&:hover": {
            opacity: 0.75,
        },
        "&.active": {
            background: "linear-gradient(90deg, #00B0E1 0%, #9DDDFC 100%)",
            color: "#fff",
            borderTop: "2px solid #1648CE",
            pointerEvents: "none",
            transform: "translateY(0px)",
        },
        "& .text-typo": {
            marginBottom: 0,
            fontWeight: 600,
        },
    },
    boxlistQueue: {
        height: 50,
        textAlign: "center",
        padding: "1.25rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        background: "linear-gradient(90deg, #CFD9DF 0%, #E2EBF0 100%)",
        color: "#fff",
        transition: "all .15s",
        "&:hover": {
            opacity: 0.75,
        },
        "&.active": {
            background: "linear-gradient(90deg, #00B0E1 0%, #9DDDFC 100%)",
            color: "#fff",
            borderTop: "2px solid #1648CE",
            pointerEvents: "none",
            transform: "translateY(0px)",
        },
        "& .text-typo": {
            marginBottom: 0,
            fontWeight: 600,
        },
    },
}));

export const useStyleFinanceTab = makeStyles(theme => ({
    selectStatus: {
        "& .MuiOutlinedInput-inputMarginDense": {
            paddingTop: "6px !important",
            paddingBottom: "6px !important",
        },
        "&.complete": {
            background: Color.green,
            color: "#fefefe",
        },
        "&.pending": {
            background: Color.yellow,
            color: "#fefefe",
        },
    },
}));

export const initialTableOptions = {
    pageSize: 20,
    pageSizeOptions: [5, 10, 20, 50],
    actionsColumnIndex: -1,
    emptyRowsWhenPaging: false,
    headerStyle: {
        fontSize: 15,
    },
    debounceInterval: 500,
    // have not affect table
    totalData: 0,
    order: "",
    direction: "",
};
